import React, { Component } from "react";
import { connect } from "react-redux";
import {changeSubField, getSubField} from "../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../contexts/FieldGroupContext";
import getDataSources from "../Endpoint/DataSources";
import {updateCustomTables} from "../../../../store/actions/customTables";

class Field extends Component {

	render() {
		const { changeSubField, customTables } = this.props;
		const {
			id,
			inputType,
			source,
			sourceName,
			sourceValue,
			defaultValue,
			label,
			dynamic,
			singleField,
			fetchType,
			dependsValue,
			dependsType,
			dependsField
		} = this.props.data;
		const { groupId, group, fieldIndex, currentItem, endpoints } = this.props;
		const action = this.props.action ? this.props.action : 'createPost';

		const getFieldValue = ( endpoint, group, groupId, fieldId, currentItem, action ) => {
			const fields = typeof endpoint[action][ currentItem ][ group ] !== 'undefined' ? endpoint[action][ currentItem ][ group ][ groupId ].fields : [];

      if (!fields) {
        return '';
      }

			return fields[ fields.findIndex( el => el.id === fieldId ) ] && fields[ fields.findIndex( el => el.id === fieldId ) ].value;
		};

		const getSubFieldValue = ( endpoint, group, groupId, fieldIndex, currentItem, action, inputType, item ) => {
			if ( inputType === 'checkboxes' ) {
				return -1 !== endpoint[action][currentItem][group][groupId].fields[fieldIndex].value.indexOf( typeof item === 'object' ? item.value : item );
			} else {
				return typeof endpoint[action][currentItem][group] !== 'undefined' ? endpoint[action][currentItem][group][groupId].fields[fieldIndex].value : '';
			}
		};

		return (
			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint }) => (
					<React.Fragment>

						{ ( ( 'select' === inputType && 'parameters' !== id && 'dynamic' !== id && 'dynamicValues' !== id && id !== 'value' ) ||
							( 'parameters' === id && 'parameter' === getFieldValue( endpoints[endpointId], group, groupId, 'source', currentItem, action ) ) ||
							( 'dynamicValues' === id && 'dynamic' === getFieldValue( endpoints[endpointId], group, groupId, 'source', currentItem, action ) ) ||
							( 'value' === id && 'fixedValue' === getFieldValue( endpoints[endpointId], group, groupId, 'source', currentItem, action ) ) ||
							( group === 'output' ) ||
              ( undefined !== dynamic && ! dynamic ) ||
							( undefined !== dynamic && ! dynamic && 'select' === inputType ) ) &&
							(
								(typeof dependsField === 'undefined' || !dependsField) ||
								(
									typeof dependsField !== 'undefined'
									&& dependsField
									&& dependsType === 'length'
									&& dependsValue === 1
									&& 'parameters' === dependsField && endpoints[endpointId][dependsField].length > 0
								)
							) &&
						inputType === 'select' &&
						( ( source && typeof source !== 'object' && source !== 'dynamicFetch' && getDataSources( endpoint )[ source ].length > 0 ) || ( typeof source === 'object' ) || (source === 'dynamicFetch') ) ?
							<React.Fragment>
								{getLabel(label)}
								<select
									value={getSubFieldValue( endpoint, group, groupId, fieldIndex, currentItem, action, inputType )}
									onChange={
										el => changeSubField(
											endpointId,
											group,
											groupId,
											fieldIndex,
											el.target.value,
											currentItem,
											action,
											inputType
										) }
								>
									<option value="">{ defaultValue }</option>
									{ source && typeof source !== 'object' && source !== 'dynamicFetch' && getDataSources( endpoint )[ source ].map(
										( e, index ) =>
											<option
												key={index}
												disabled={ undefined !== e.disabled && e.disabled }
												value={ e[ sourceValue ] ? e[ sourceValue ] : e } >
												{ e[ sourceName ] || e[ sourceName ] === '' ? e[ sourceName ] : e }
											</option>
									) }
									{ typeof source === 'object' && source.map(( e, index ) => <option key={index} value={ e } >{e}</option>)}
									{ source === 'dynamicFetch' && customTables.length === 0 && <option>Loading more options...</option>}
									{ source === 'dynamicFetch' && fetchType && fetchType === 'tables' && Object.keys(customTables).length > 0 && Object.keys(customTables).map(( e, index ) => <option key={index} value={ e } >{e}</option>)}
									{ source === 'dynamicFetch' && fetchType && fetchType === 'columns' && Object.keys(customTables).length > 0 && customTables[endpoint[action][0]['tableSelection'][0].fields[0]['value']].map(( e, index ) => <option key={index} value={ e } >{e}</option>)}
								</select>
							</React.Fragment> : '' }

						{ 'checkboxes' === inputType && 'value' === id && 'fixedValue' === getFieldValue( endpoints[endpointId], group, groupId, 'source', currentItem, action ) ||
						( undefined !== dynamic && ! dynamic && 'checkboxes' === inputType ) ?
							<React.Fragment>
								{getLabel(label)}
								{ source && getDataSources( endpoint )[ source ].map(
									( e, index ) =>
										<React.Fragment key={index}>
											<label>
												<input
                          className="restroutes-checkbox"
													checked={getSubFieldValue( endpoint, group, groupId, fieldIndex, currentItem, action, inputType, e )}
													onChange={
														el => changeSubField(
															endpointId,
															group,
															groupId,
															fieldIndex,
															el.target.value,
															currentItem,
															action,
															inputType
														) }
													type="checkbox"
													name={ e[ sourceName ] ? e[ sourceName ] : e }
													key={index}
													value={ e[ sourceValue ] ? e[ sourceValue ] : e }
												/>{ e[ sourceName ] ? e[ sourceName ] : e }
											</label>
										</React.Fragment>
								) }
							</React.Fragment> : '' }

						{ (
							'input' === inputType && 'value' === id && 'fixedValue' === getFieldValue( endpoints[endpointId], group, groupId, 'source', currentItem, action ) ||
							'number' === inputType ||
							( undefined !== dynamic && ! dynamic && 'input' === inputType ) ||
							('customFieldOrderBy' === id && 'custom_field' === getFieldValue( endpoints[endpointId], group, groupId, 'value', currentItem, action ) ) ||
							( undefined !== singleField && singleField )
						) &&
						(
							(typeof dependsField === 'undefined' || !dependsField) ||
							(
								typeof dependsField !== 'undefined'
								&& dependsField
								&& dependsType === 'length'
								&& dependsValue === 1
								&& 'parameters' === dependsField && endpoints[endpointId][dependsField].length > 0
							)
						)
							?
							<React.Fragment>
								{getLabel(label)}
								<input className={id}
									value={getSubFieldValue( endpoint, group, groupId, fieldIndex, currentItem, action, inputType )}
									onChange={
										el => changeSubField(
											endpointId,
											group,
											groupId,
											fieldIndex,
											el.target.value,
											currentItem,
											action,
											inputType
										) } type={inputType === 'number' ? 'number' : 'text'}
								/>
							</React.Fragment> : '' }

            { 'input-password' === inputType
              ?
              <React.Fragment>
                {getLabel(label)}
                <input className={id}
                       value={getSubFieldValue( endpoint, group, groupId, fieldIndex, currentItem, action, inputType )}
                       onChange={
                         el => changeSubField(
                           endpointId,
                           group,
                           groupId,
                           fieldIndex,
                           el.target.value,
                           currentItem,
                           action,
                           inputType
                         ) } type='password'
                />
              </React.Fragment> : '' }

						{ 'p' === inputType  ?
							<React.Fragment>
								<p>{label}</p>
							</React.Fragment> : '' }

						{ ('small' === inputType)
								&& typeof dependsField !== 'undefined'
								&& dependsField
								&& (dependsType === 'length')
								&& (dependsValue === 0)
								&& ('parameters' === dependsField && endpoints[endpointId][dependsField].length === 0)
							?
							<React.Fragment>
								<div className="SmallText"><small>{label}</small></div>
							</React.Fragment> : '' }

						{ 'textarea' === inputType && 'value' === id && 'fixedValue' === getFieldValue( endpoints[endpointId], group, groupId, 'source', currentItem, action ) ||
						( undefined !== dynamic && ! dynamic && 'textarea' === inputType ) ||
						( undefined !== singleField && singleField ) ?
							<React.Fragment>
								{getLabel(label)}
								<textarea id={id}
									onChange={
										el => changeSubField(
											endpointId,
											group,
											groupId,
											fieldIndex,
											el.target.value,
											currentItem,
											action,
											inputType
										) }
									value={getSubFieldValue( endpoint, group, groupId, fieldIndex, currentItem, action, inputType )}
								/>
							</React.Fragment> : '' }
					</React.Fragment>

				)}

			</FieldGroupContext.Consumer>
		);
	}
};

const getLabel = ( label ) => {
	return label ? <label>{label}: </label> : '';
}

const mapStateToProps = ( state, props ) => ({
	renderRemoveField: props.renderRemoveField,
	endpoints: state.settings.endpoints,
	customTables: state.customTables,
});

const mapDispatchToProps = dispatch => ({
	updateCustomTables: (value) => dispatch(updateCustomTables(value)),
	changeSubField: (
		endpointId,
		group,
		groupId,
		fieldIndex,
		value,
		currentItem,
		action,
		inputType ) => dispatch(
			changeSubField(
				endpointId,
				group,
				groupId,
				fieldIndex,
				value,
				currentItem,
				action,
				inputType
			)
	)
});

export default connect(mapStateToProps, mapDispatchToProps)(Field);
